import { mapGetters, mapActions, mapMutations } from 'vuex'
import { uuid } from 'vue-uuid'
import MessageStatus from '../../helper/messageTypes'
import { version } from '../../../package.json'
import BotIds from '../../helper/idBotSound'

export default {
  name: 'ChatStructure',

  data () {
    return {
      isShowPreview: false,
      isWritingLoading: false,
      uploadingFile: false,
      fileData: {},
      paramsDefault: {},
      audioPlay: null,
      bots: BotIds
    }
  },
  computed: {
    ...mapGetters([
      '$getterIsDebugger',
      'getterSelectedBot',
      'getterSettingWebchat',
      'getterChatSearching',
      'getterIsSacContext',
      '$getterSendText',
      '$getterConversation',
      '$getterSendTextFile',
      '$getterErrorFile',
      '$getterSendBtnMenu',
      '$getterIsSacContext',
      'getterIsPlaySound',
      '$getterSoundMessage'
    ])
  },
  watch: {
    getterSettingWebchat () {
      this.paramsDefault = {
        channelId: 'peoplechat',
        type: 'message',
        botId: this.getterSettingWebchat.botId,
        userId: this.getterSettingWebchat.userId,
        username: this.getterSettingWebchat.username,
        conversationId: this.getterSettingWebchat.userId,
        event: ''
      }
    },
    $getterSendText (to) {
      if (to) {
        const objMessage = {
          id: uuid.v4(),
          resourceType: 'text',
          text: to,
          color: this.$vuetify.theme.currentTheme.chatMessage,
          userType: 'message',
          msgTooltip: 'waiting',
          date: new Date().toISOString(),
          status: MessageStatus.WAITING,
          debuggerOptions: this.$getterIsSacContext ? { isSacContext: true } : null
        }
        this.$actionConversation(objMessage)
        this.$actionIsBotResponse(true)
        this.send(objMessage)
      }
    },
    $getterSendTextFile (to) {
      if (to) {
        if (!to.id) {
          let type = to.type.split('/').shift()
          type = type === 'text' ? 'application' : type
          const objMessage = {
            id: uuid.v4(),
            text: to.text,
            name: to.name,
            resourceType: type,
            type: to.type,
            base64: to.base64,
            extension: to.extension,
            color: this.$vuetify.theme.currentTheme.chatMessage,
            userType: 'message',
            msgTooltip: 'waiting',
            date: new Date().toISOString(),
            isLoading: true,
            status: MessageStatus.WAITING
          }
          this.$actionConversation(objMessage)
          this.send(objMessage)
        } else if (to.id && to.text) {
          this.send({
            id: uuid.v4(),
            resourceType: 'text',
            text: to.text,
            date: new Date().toISOString()
          })
        }
      }
    },
    $getterErrorFile (to) {
      this.addToastDanger(to, 6000)
    },
    $getterSendBtnMenu (to) {
      const objMessage = {
        id: uuid.v4(),
        resourceType: 'text',
        text: to.title,
        value: to.value,
        color: this.$vuetify.theme.currentTheme.chatMessage,
        userType: 'message',
        msgTooltip: 'waiting',
        date: new Date().toISOString(),
        status: MessageStatus.WAITING
      }
      if (to.type === 'imBack') {
        this.$actionConversation(objMessage)
        this.$actionIsBotResponse(true)
      }
      this.send(objMessage, true)
    },
    getterIsPlaySound (to) {
      if (to) {
        this.playSound()
      }
    }
  },
  sockets: {
    uploadFileSuccess (data) {
      this.sendFileSuccess(data)
    }
  },
  mounted () {
    this.$actionVersion(version)
    this.$actionClearMessage()
    this.paramsDefault = {
      channelId: 'peoplechat',
      type: 'message',
      botId: this.getterSettingWebchat.botId,
      userId: this.getterSettingWebchat.userId,
      username: this.getterSettingWebchat.username,
      conversationId: this.getterSettingWebchat.conversationId,
      event: ''
    }

    this.$eventBus.$on('send-message', this.send)

    this.checkIsPlaySound()

    this.$mutationVlibrasShowBtn(true)
    this.$mutationEnableCarouselNavArrows(true)
  },
  beforeDestroy () {
    window.removeEventListener('click', () => {})
    this.$eventBus.$off('send-message')
  },
  methods: {
    ...mapMutations([
      '$mutationVlibrasShowBtn',
      '$mutationEnableCarouselNavArrows'
    ]),
    ...mapActions([
      'actionEmitMessage',
      'actionEmitUploadFile',
      '$actionConversation',
      '$actionClearMessage',
      '$actionIsBotResponse',
      '$actionVersion',
      '$actionSoundMessage'
    ]),
    send (message, isButton) {
      window.VLibras.Widget.ReloadTagsTexts()
      if (message.resourceType && message.resourceType === 'text') {
        this.actionEmitMessage({
          ...this.paramsDefault,
          id: message.id,
          message: isButton ? message.value : message.text
        })
      } else if (message.resourceType) {
        const file = {
          base64: message.base64,
          extension: message.name.split('.').pop(),
          id: message.resourceType === 'application' ? 'file' : message.resourceType,
          name: message.name,
          type: message.type,
          cod: message.id
        }

        this.actionEmitUploadFile([file])

        this.paramsDefault.message = ''
      } else {
        this.actionEmitMessage({
          ...this.paramsDefault,
          id: uuid.v4(),
          message: message.value
        })
      }
    },
    sendFileSuccess (params) {
      const data = {
        ...this.paramsDefault,
        id: params.id,
        attachments: params
      }
      this.actionEmitMessage(data)
    },
    checkIsPlaySound () {
      if (this.bots.includes(this.$route.params.botId)) {
        this.audioPlay = new Audio('/sound/toque-sms.mp3')
        this.audioPlay.autofocus = true
        this.$actionSoundMessage({ isSound: true, onOff: true })
      } else {
        this.$actionSoundMessage({ isSound: false, onOff: false })
      }
    },
    playSound () {
      if (this.$getterSoundMessage.onOff) {
        this.audioPlay.play()
      }
    }
  }
}
